<template>
  <v-dialog v-model="dialog" max-width="500">
    <v-card>
      <v-card-title>Ajuste</v-card-title>
      <v-card-text>
        <v-form v-model="isValid">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="adjustment.description"
                label="Descrição"
                outlined
                hide-details
                :rules="[(v) => !!v || 'Descrição é obrigatório']"
              />
            </v-col>
            <v-col cols="12">
              <v-btn-toggle
                v-model="type"
                mandatory
                :color="type === 'add' ? 'success' : 'error'"
                class="d-flex"
              >
                <v-btn value="add" class="flex-grow-1" height="40">
                  <v-icon left :color="type === 'add' ? 'success' : ''">
                    mdi-plus
                  </v-icon>
                  Crédito
                </v-btn>
                <v-btn value="subtract" class="flex-grow-1" height="40">
                  <v-icon left :color="type === 'add' ? '' : 'error'">
                    mdi-minus
                  </v-icon>
                  Débito
                </v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="adjustment.amount"
                label="Valor"
                type="number"
                :prefix="`${type === 'add' ? '+' : '-'}R$`"
                required
                outlined
                hide-details
                min="0"
                :rules="[
                  (v) => !!v || 'Valor é obrigatório',
                  (v) => v > 0 || 'Valor deve ser maior que 0',
                ]"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="adjustment.type"
                :items="categories[type]"
                label="Categoria"
                required
                class="mb-2"
                outlined
                hide-details
              />
            </v-col>
          </v-row>
        </v-form>

        <v-alert
          v-if="type === 'subtract'"
          icon="mdi-tray-arrow-up"
          type="error"
          class="mb-0"
          text
        >
          O valor de {{ adjustment.amount | currency(true) }} será subtraído do
          saldo do evento.
        </v-alert>
        <v-alert
          v-if="type === 'add'"
          icon="mdi-tray-arrow-down"
          type="success"
          class="mb-0"
          text
        >
          O valor de {{ adjustment.amount | currency(true) }} será adicionado ao
          saldo do evento.
        </v-alert>

        <v-alert v-if="error" type="error" class="mb-0 mt-2" text>
          {{ error }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="close" text :disabled="loading">Cancelar</v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          @click="save"
          :loading="loading"
          :disabled="!isValid"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PARTY from "@/services/admin/parties";

export default {
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      isValid: false,
      loading: false,
      error: null,
      adjustment: this.defaultAdjustment(),
      type: "subtract",
      categories: {
        subtract: [
          { value: "DEBIT", text: "Débito" },
          { value: "TAX", text: "Imposto" },
          { value: "FEE", text: "Taxa" },
          { value: "FINE", text: "Multa" },
          { value: "OTHER", text: "Outro" },
        ],
        add: [
          { value: "CREDIT", text: "Crédito" },
          { value: "CASHBACK", text: "Cashback" },
          { value: "DISCOUNT", text: "Desconto" },
          { value: "BONUS", text: "Bônus" },
          { value: "REFUND", text: "Reembolso" },
          { value: "OTHER", text: "Outro" },
        ],
      },
    };
  },
  methods: {
    open(adjustment) {
      this.adjustment = Object.assign({}, this.defaultAdjustment(), adjustment);
      this.type = adjustment.amount > 0 ? "add" : "subtract";
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },

    async save() {
      this.loading = true;
      this.error = null;
      try {
        const data = {
          description: this.adjustment.description,
          amount: this.adjustment.amount,
          type: this.adjustment.type,
        };

        if (this.type === "subtract") {
          data.amount = -data.amount;
        }

        await PARTY.createAdjustment(this.party.id, data);
        this.$emit("success");
        this.close();
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },

    defaultAdjustment() {
      return {
        description: "",
        amount: 0,
        type: "DEBIT",
      };
    },
  },
  watch: {
    type(newVal) {
      this.adjustment.type = this.categories[newVal][0].value;
    },
  },
  mounted() {
    this.$root.$on("party-adjustments-modal", (adjustment) => {
      this.dialog = true;
      this.adjustment = Object.assign({}, this.defaultAdjustment(), adjustment);
    });
  },
};
</script>
